module.exports = __webpack_public_path__ + "media/flags/021-mexico-7b5f77ad.svg";